<template>
  <v-container v-if="$checkPermission('number_of_students_by_canton')" :class="{'v3_index_view':  $vuetify.breakpoint.mdAndUp, 'pa-0': $vuetify.breakpoint.smAndDown}">
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="8" md="6" class="pt-6 pb-6">
            <span class="headline font-weight-light">
                   Broj učenika po školama
                   <v-icon slot="divider" @click="getData()" style="padding-bottom: 2px;">mdi-refresh</v-icon>
                </span>

        <v-breadcrumbs :items="breadcrumbs" style="padding-left: 0; padding-bottom: 0;">
          <template v-slot:divider>
            <v-icon>mdi-chevron-right</v-icon>
          </template>
        </v-breadcrumbs>

      </v-col>
    </v-row>
    <v-row class="mx-0" :class="{'v3_heading_mobile_view': $vuetify.breakpoint.smAndDown}">
      <v-col cols="12" md="4">
        <v-text-field
            outlined
            label="Pretraga"
            v-model="search"
            hide-details
            dense
            prepend-inner-icon="mdi-magnify"
        ></v-text-field>
      </v-col>

      <v-col v-if="!isCantonCoordinator" cols="12" md="4">
        <v-autocomplete
            outlined
            :items="cantons"
            item-text="title"
            item-value="id"
            hide-details
            label="Odaberi županiju..."
            v-model="select_canton"
            dense
            @change="getDataTable()"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="4">
        <v-autocomplete
            outlined
            :items="school_years"
            item-text="title"
            item-value="id"
            hide-details
            label="Odaberi školsku godinu..."
            v-model="select_school_year"
            dense
            @change="getDataTable()"
        ></v-autocomplete>
      </v-col>


      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="dataTable"
            :search="search"
            class="elevation-1"
            loading-text="Traženje..."
            :footer-props="{itemsPerPageText: 'Redaka po stranici:'}"
            :header-props="{sortByText: 'Poredaj po'}">
          <template v-slot:[`item.teacher_subjects`]>
            <span style="color: #084776">{{ select_subject_title }}</span>
          </template>
          <template v-slot:no-data>
            <span>
                Za tražene pojmove nema rezultata pretrage.
            </span>
          </template>

          <template v-slot:footer.page-text="items"> Prikazano {{ items.pageStart }} do {{ items.pageStop }} od ukupno
            {{ items.itemsLength }} rezultata
          </template>

          <template v-slot:[`item.actions`]="{ item }">

            <v-btn color="primary" @click="showAllStudents(item)" class="small-btn">
              <v-tooltip color="primary" bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-on="on" v-bind="attrs"
                  >mdi-magnify
                  </v-icon
                  >
                </template
                >
                Pregled učenika u školi
              </v-tooltip
              >
            </v-btn>

            <v-btn color="primary" @click="showNationality(item)" class="small-btn">
              <v-tooltip color="primary" bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon v-on="on" v-bind="attrs"
                  >mdi-flag
                  </v-icon
                  >
                </template
                >
                Pregled nacionalnosti
              </v-tooltip
              >
            </v-btn>

          </template>
        </v-data-table>
      </v-col>
    </v-row>

    <v-dialog
        v-model="dialog"
        width="500"
        @click:outside="lockDialog = false"
    >
      <v-card>
        <v-card-title class="d-flex justify-space-between" >Nacionalnosti u školi</v-card-title>
        <v-card-text class="pt-5">
          <v-simple-table>
            <thead>
            <tr>
              <th class="text-left">Nacionalnost</th>
              <th class="text-left">Broj učenika</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item, index) in studentNationality" :key="index">
              <td>{{ item.nationality }}</td>
              <td>{{ item.count }}</td>
            </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>

  </v-container>

</template>

<script>
import ApiV2 from "@/services/ApiV2";

export default {
  name: "StudentsInCantonForSchoolYear",
  computed: {
    isCantonCoordinator() {
      return parseInt(this.role) === 2;
    }
  },
  data() {
    return {
      breadcrumbs: [
        {text: "Administracija"},
        {text: "Izvještaji"},
        {text: "Broj učenika po školama u županiji"},
      ],
      dialog: false,
      show_add_view: false,
      show_table_view: false,
      dataTable: [],
      headers: [
        {
          text: "Naziv skole",
          value: "school_name",
        },
        {
          text: "Broj učenika",
          value: "user_count",
        },
        {
          text: "Akcija",
          value: "actions",
          sortable: false,
        }

      ],
      studentNationality: [],
      search: "",
      select_canton: "",
      cantons: [],
      school_years: [],
      select_school_year: "",
      role: null
    };
  },
  mounted() {
    this.role = localStorage.getItem('role_id');
    this.getData();
  },
  methods: {
    async getData() {
      let {data} = await ApiV2.get('reports/students_per_canton/filters');

      this.cantons = data.cantons;
      this.school_years = data.school_years;
      this.select_canton = this.select_canton || data.default_canton_id || this.cantons[0]?.id || "";
      this.select_school_year = this.select_school_year || data.default_school_year_id;

      if (this.select_canton && this.select_school_year) {
        this.getDataTable();
      }
    },
    async getDataTable() {
      if (!this.select_canton || !this.select_school_year) {
        return;
      }

      let {data} = await ApiV2.get('reports/students_per_canton', {
        params: {
          canton_id: this.select_canton,
          school_year_id: this.select_school_year,
        }
      });

      this.dataTable = data;
    },
    showAllStudents(item) {
      this.$router.push({
        path: '/admin/izvjestaj/studenti_skolama_popis',
        query: {school: item.school_id, year: this.select_school_year}
      });
    },
    showNationality(item) {
      let school = item.school_id;
      console.log(school);

      ApiV2.get(`reports/students_per_school/${school}/nationalities`, {
        params: {
          school_year_id: this.select_school_year,
        }
      }).then((response) => {
        this.studentNationality = this.formattedNationalities(response.data);
        console.log(this.studentNationality);
      })
     this.dialog = true;
    },

    formattedNationalities(data) {
      return data.map((item) => {
        return {
          nationality: item.nationality && item.nationality !== '-' ? item.nationality : 'neodređeno',
          count: item.count,
        };
      });
    },


  }
}
</script>

<style scoped>
.small-btn {

  margin-right: 8px;

}
</style>
